module.exports = __webpack_public_path__ + "img/dingdan.9d22c89c.svg";